export default __webpack_public_path__ + "static/media/p5-1.04fca480.png";